<div class="idp-generic-content" [ngClass]="type ? type : ''">
  <h2
    *ngIf="title"
    [attr.data-test-generic-title]="title"
    [innerHTML]="title | trustContent : 'html'"
    class="idp-generic-content__title"
  ></h2>
  <div
    *ngIf="message"
    [attr.data-test-generic-message]="message"
    [innerHTML]="message | trustContent : 'html'"
    class="idp-generic-content__message"
  ></div>
</div>
